// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 900px) and (max-width: 4000px) {
  body:has(.thank-page-wrapper) {
    overflow-y: hidden !important;
  }

  .thank-page-wrapper {
    min-height: 100vh !important;
    padding: 0;
    transform: scale(1);
    overflow-y: hidden;
    position: absolute;
    top: -1rem;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .thankyou-card {
    max-width: 600px !important; /* Increased width for laptop */
    width: 100%;
    min-height: 600px !important; /* Increased height for laptop */
    margin: 20px auto;
    padding: 2rem;
    background: #fff;
    border-radius: 20px;
  }

  .thankyou-card .card-body {
    padding: 0 24px; /* Increased padding for laptop */
  }

  .thankyou-card h4 {
    font-size: 36px; /* Larger font for laptop */
    line-height: 42px;
  }

  .thankyou-card .info-txt {
    font-size: 20px; /* Larger font for laptop */
    line-height: 30px;
  }

  .thank-page-wrapper .continue-btn {
    width: 400px; /* Wider button for laptop */
  }
}

/* Keep existing mobile styles unchanged */
@media (min-width: 360px) and (max-width: 430px) {
  /* Your existing mobile styles here */
  body:has(.thank-page-wrapper) {
    overflow-y: hidden !important;
  }

  .thank-page-wrapper {
    min-height: 89vh !important;
    padding: 0 4px;
    transform: scale(0.8);
    overflow-y: hidden;
    position: absolute;
    top: -3.44rem;
    left: 0;
    right: 0;
  }
}

/* Improved link styles */
.thankyou-card .result-link {
  display: inline-block;
  margin: 1rem auto;
  padding: 12px 24px;
  background: linear-gradient(92deg, #72d8da 2.79%, #35c6c9 90.54%);
  color: #fff !important;
  text-decoration: none !important;
  border-radius: 30px;
  font-weight: 600;
  font-size: 18px;
  transition: all 0.3s ease;
  box-shadow: 0px 4px 15px rgba(53, 198, 201, 0.3);
}

.thankyou-card .result-link:hover {
  transform: translateY(-2px);
  box-shadow: 0px 6px 20px rgba(53, 198, 201, 0.4);
}

/* Keep your existing base styles */
.thankyou-card {
  max-width: 390px;
  min-height: 524px;
  margin: 50px auto;
}

.thankyou-card .card-body {
  padding: 0 8px;
  margin-top: 14px;
  margin-bottom: 14px;
}

/* Rest of your existing styles remain unchanged */
.thankyou-card h4 {
  color: #000;
  text-align: center;
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: 35px;
}

.thankyou-card .info-txt {
  color: #000;
  font-size: 17px;
  font-style: normal;
  font-weight: 500;
  line-height: 25px;
}

.loginSwiper .swiper-button-next,
.loginSwiper .swiper-button-prev {
  display: none;
}

.thank-page-wrapper .continue-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 320px;
  height: 65px;
  flex-shrink: 0;
  border-radius: 40px;
  background: linear-gradient(92deg, #72d8da 2.79%, #35c6c9 90.54%);
  box-shadow:
    0px 35px 35px 0px rgba(0, 0, 0, 0.09),
    0px 9px 19px 0px rgba(0, 0, 0, 0.1);
  color: #fff;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-decoration: none;
}

.thank-page-wrapper .swiper-pagination-bullet-active {
  background: #72d8da !important;
}

.thank-page-wrapper .MuiFilledInput-underline {
  border-radius: 40px !important;
}

.thank-page-wrapper .MuiFilledInput-underline:before,
.thank-page-wrapper .MuiFilledInput-underline::after {
  border-bottom: 0 !important;
}

.thank-page-wrapper .custom-input-email label {
  font-size: 19px !important;
  margin-left: 10px !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Thankyou/thankyou.css"],"names":[],"mappings":"AAAA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;IAC5B,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,QAAQ;IACR,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,2BAA2B,EAAE,+BAA+B;IAC5D,WAAW;IACX,4BAA4B,EAAE,gCAAgC;IAC9D,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe,EAAE,iCAAiC;EACpD;;EAEA;IACE,eAAe,EAAE,2BAA2B;IAC5C,iBAAiB;EACnB;;EAEA;IACE,eAAe,EAAE,2BAA2B;IAC5C,iBAAiB;EACnB;;EAEA;IACE,YAAY,EAAE,4BAA4B;EAC5C;AACF;;AAEA,0CAA0C;AAC1C;EACE,qCAAqC;EACrC;IACE,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;IAC3B,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,QAAQ;EACV;AACF;;AAEA,yBAAyB;AACzB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,iEAAiE;EACjE,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,iEAAiE;EACjE;;uCAEqC;EACrC,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B","sourcesContent":["@media (min-width: 900px) and (max-width: 4000px) {\n  body:has(.thank-page-wrapper) {\n    overflow-y: hidden !important;\n  }\n\n  .thank-page-wrapper {\n    min-height: 100vh !important;\n    padding: 0;\n    transform: scale(1);\n    overflow-y: hidden;\n    position: absolute;\n    top: -1rem;\n    left: 0;\n    right: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .thankyou-card {\n    max-width: 600px !important; /* Increased width for laptop */\n    width: 100%;\n    min-height: 600px !important; /* Increased height for laptop */\n    margin: 20px auto;\n    padding: 2rem;\n    background: #fff;\n    border-radius: 20px;\n  }\n\n  .thankyou-card .card-body {\n    padding: 0 24px; /* Increased padding for laptop */\n  }\n\n  .thankyou-card h4 {\n    font-size: 36px; /* Larger font for laptop */\n    line-height: 42px;\n  }\n\n  .thankyou-card .info-txt {\n    font-size: 20px; /* Larger font for laptop */\n    line-height: 30px;\n  }\n\n  .thank-page-wrapper .continue-btn {\n    width: 400px; /* Wider button for laptop */\n  }\n}\n\n/* Keep existing mobile styles unchanged */\n@media (min-width: 360px) and (max-width: 430px) {\n  /* Your existing mobile styles here */\n  body:has(.thank-page-wrapper) {\n    overflow-y: hidden !important;\n  }\n\n  .thank-page-wrapper {\n    min-height: 89vh !important;\n    padding: 0 4px;\n    transform: scale(0.8);\n    overflow-y: hidden;\n    position: absolute;\n    top: -3.44rem;\n    left: 0;\n    right: 0;\n  }\n}\n\n/* Improved link styles */\n.thankyou-card .result-link {\n  display: inline-block;\n  margin: 1rem auto;\n  padding: 12px 24px;\n  background: linear-gradient(92deg, #72d8da 2.79%, #35c6c9 90.54%);\n  color: #fff !important;\n  text-decoration: none !important;\n  border-radius: 30px;\n  font-weight: 600;\n  font-size: 18px;\n  transition: all 0.3s ease;\n  box-shadow: 0px 4px 15px rgba(53, 198, 201, 0.3);\n}\n\n.thankyou-card .result-link:hover {\n  transform: translateY(-2px);\n  box-shadow: 0px 6px 20px rgba(53, 198, 201, 0.4);\n}\n\n/* Keep your existing base styles */\n.thankyou-card {\n  max-width: 390px;\n  min-height: 524px;\n  margin: 50px auto;\n}\n\n.thankyou-card .card-body {\n  padding: 0 8px;\n  margin-top: 14px;\n  margin-bottom: 14px;\n}\n\n/* Rest of your existing styles remain unchanged */\n.thankyou-card h4 {\n  color: #000;\n  text-align: center;\n  font-size: 30px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 35px;\n}\n\n.thankyou-card .info-txt {\n  color: #000;\n  font-size: 17px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 25px;\n}\n\n.loginSwiper .swiper-button-next,\n.loginSwiper .swiper-button-prev {\n  display: none;\n}\n\n.thank-page-wrapper .continue-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 320px;\n  height: 65px;\n  flex-shrink: 0;\n  border-radius: 40px;\n  background: linear-gradient(92deg, #72d8da 2.79%, #35c6c9 90.54%);\n  box-shadow:\n    0px 35px 35px 0px rgba(0, 0, 0, 0.09),\n    0px 9px 19px 0px rgba(0, 0, 0, 0.1);\n  color: #fff;\n  text-align: center;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  text-decoration: none;\n}\n\n.thank-page-wrapper .swiper-pagination-bullet-active {\n  background: #72d8da !important;\n}\n\n.thank-page-wrapper .MuiFilledInput-underline {\n  border-radius: 40px !important;\n}\n\n.thank-page-wrapper .MuiFilledInput-underline:before,\n.thank-page-wrapper .MuiFilledInput-underline::after {\n  border-bottom: 0 !important;\n}\n\n.thank-page-wrapper .custom-input-email label {\n  font-size: 19px !important;\n  margin-left: 10px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
